
import Vue, { Component } from 'vue'
// import { mapGetters } from 'vuex'

import GardenMap from '@/ui/components/gardens/GardenMap.vue'
import AddPlant from '@/ui/components/AddPlant.vue'
// import PlantsInfoCard from '@/ui/components/plants/PlantsInfoCard.vue'

// import AddHarvest from '@/ui/components/AddHarvest.vue'
// import AddLog from '@/ui/components/AddLog.vue'
// import AddImage from '@/ui/components/AddImage.vue'

import Plant from '@/models/Plant'
import { id } from '@/types/models'
import Garden from '@/models/Garden'

interface Drawer {
  id?: string
  component?: Component
  type?: string
}

type ButtonProps = any

export default Vue.extend({
  components: {
    GardenMap,
    // PlantsInfoCard,
    AddPlant,
  },
  props: {
    gardenId: String, // Object as PropType<GardenDefinition>,
  },
  data: () => ({
    selectedPlantIds: [] as Array<id>,
    drawer: {} as Drawer,

    plantInfoDialog: false,
    addPlantDialog: false,
  }),
  computed: {
    garden(): Garden {
      return this.$store.getters['garden'](this.gardenId)
    },
    isInitialized(): boolean {
      return this.$store.state.gardens.isInitialized
    },
    plants(): Array<Plant> {
      // return this.$store.getters['plants/plantsInGarden'](this.garden.id)
      return this.garden.plants
    },
    activePlants(): Array<Plant> {
      return this.plants.filter((p) => p.isActive)
    },
    showDialog(): boolean {
      return !!this.$route.meta?.showDialog
    },
    dialogIsScrollable(): boolean {
      return !!this.$route.meta?.dialogIsScrollable
    },
    buttons(): ButtonProps[] {
      return [
        {
          icon: '$select-all',
          disabled: this.selectedPlantIds.length >= this.activePlants.length,
          tooltip: 'Select All',
          click: () =>
            (this.selectedPlantIds = this.activePlants.map((p: Plant) => p.id)),
        },
        {
          icon: '$deselect-all',
          disabled: this.selectedPlantIds.length < 1,
          tooltip: 'Deselect all',
          click: () => (this.selectedPlantIds = []),
        },
        // { type: 'divider' },
        {
          icon: '$info',
          // disabled: this.selectedPlantIds.length < 1,
          disabled: false,
          tooltip: 'Plant Info',
          // click: () => this.plantInfoDialog = true,
          // click: () => this.$router.push({ name: 'garden/info', params: { plantIds: this.selectedPlantIds.join(',') } })
          // to: { name: 'garden/info', params: { gardenId: this.gardenId, plantIds: this.selectedPlantIds.join(',') || undefined } },
          to: {
            name: 'garden/info',
            params: {
              gardenId: this.gardenId,
              plantId:
                this.selectedPlantIds?.length > 0
                  ? this.selectedPlantIds[0]
                  : this.plants?.length > 0
                  ? this.plants[0].id
                  : undefined,
            },
          },
        },
        // {
        //   icon: '$location',
        //   disabled: this.selectedPlantIds.length !== 1,
        //   tooltip: 'Move Plant',
        //   click: () => this.drawer = 'location',
        // },
        { type: 'divider' },
        {
          icon: '$image',
          disabled: this.selectedPlantIds.length <= 0,
          tooltip: 'Add Image',
          // click: () => this.drawer = {
          //   id: 'image',
          //   component: AddImage,
          // },
          to: {
            name: 'garden/add/image',
            params: {
              gardenId: this.gardenId,
              plantIds: this.selectedPlantIds.join(',') || undefined,
            },
          },
        },
        {
          icon: '$milestone',
          disabled: this.selectedPlantIds.length <= 0,
          tooltip: 'Add Milestone',
          // click: () => this.drawer = {
          //   id: 'milestone',
          //   component: AddLog,
          // },
          to: {
            name: 'garden/add/log',
            params: {
              gardenId: this.gardenId,
              plantIds: this.selectedPlantIds.join(',') || undefined,
              category: 'milestone',
            },
          },
        },
        {
          icon: '$action',
          disabled: this.selectedPlantIds.length <= 0,
          tooltip: 'Add Action/Event',
          // click: () => this.drawer = {
          //   id: 'action',
          //   component: AddLog,
          // },
          to: {
            name: 'garden/add/log',
            params: {
              gardenId: this.gardenId,
              plantIds: this.selectedPlantIds.join(',') || undefined,
              category: 'action',
            },
          },
        },
        {
          icon: '$water',
          disabled: this.selectedPlantIds.length <= 0,
          tooltip: 'Log Water',
          to: {
            name: 'garden/add/log',
            params: {
              gardenId: this.gardenId,
              plantIds: this.selectedPlantIds.join(',') || undefined,
              category: 'water',
            },
          },
        },
        {
          icon: '$comment',
          disabled: this.selectedPlantIds.length <= 0,
          tooltip: 'Add Comment',
          // click: () => this.drawer = {
          //   id: 'comment',
          //   component: AddLog,
          //   type: 'n/a',
          // },
          to: {
            name: 'garden/add/log',
            params: {
              gardenId: this.gardenId,
              plantIds: this.selectedPlantIds.join(',') || undefined,
              category: 'comment',
            },
          },
        },
        // { type: 'divider' },
        {
          icon: '$harvest',
          disabled: this.selectedPlantIds.length !== 1,
          tooltip: 'Add Harvest',
          // click: () => this.drawer = {
          //   id: 'harvest',
          //   component: AddHarvest,
          // },
          to:
            this.selectedPlantIds.length > 0
              ? {
                  name: 'garden/add/harvest',
                  params: {
                    gardenId: this.gardenId,
                    plantId: this.selectedPlantIds[0],
                  },
                }
              : undefined,
        },
      ]
    },
  },
  created() {
    // console.log(this.$router, this.$route.meta.showDialog)
  },
  methods: {
    closeDialog(): void {
      this.$router.push({ name: 'garden' })
    },
    closeDrawer(): void {
      this.drawer = {}
    },
  },
})
